// models/NotaItem.js
export class NotaItem {
  constructor() {
    this.id = 0;
    this.notaId = 0;
    this.produtoId = 0;
    this.comandaItemId = null;
    this.ordemServicoItemId = null;
    this.item = 0;
    this.cfop = '';
    this.unCom = '';
    this.qtdCom = 0;
    this.vUnCom = 0;
    this.vProd = 0;
    this.xProd = '';
    this.idAnotaAi = '';
    this.produto = null;
  }

  // setQtdCom(qtd) {
  //   this.qtdCom = parseFloat(qtd);
  //   this.recalcularTotal();
  // }

  // setVUnCom(valor) {
  //   this.vUnCom = parseFloat(valor);
  //   this.recalcularTotal();
  // }

  // recalcularTotal() {
  //   this.vProd = parseFloat(this.qtdCom || 0) * (this.vUnCom || 0);
  // }
}
